"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var Config = exports["default"] = /*#__PURE__*/function () {
  function Config() {
    (0, _classCallCheck2["default"])(this, Config);
  }
  return (0, _createClass2["default"])(Config, null, [{
    key: "setConfiguration",
    value: function setConfiguration(configuration) {
      this.configuration = configuration;
    }
  }, {
    key: "getConfiguration",
    value: function getConfiguration() {
      return this.configuration;
    }
  }]);
}();
(0, _defineProperty2["default"])(Config, "configuration", void 0);